<template>
  <div
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-form label-position="right" label-width="80px" :model="searchParams" class="search-form">
      <el-form-item label="姓名" class="search-box">
        <el-input v-model="searchParams.userName"></el-input>
      </el-form-item>
      <el-form-item label="手机号码" class="search-box">
        <el-input v-model="searchParams.mobile"></el-input>
      </el-form-item>
      <el-form-item label="课程状态" class="search-box">
        <el-select v-model="searchParams.courseStatus" placeholder="请选择">
          <el-option
            v-for="item in courseStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="预约时间" class="time-box">
        <el-date-picker
          v-model="searchTime"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="searchTiming"
          style="width:100%"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="订单状态" class="search-box">
        <el-select v-model="searchParams.status" placeholder="请选择">
          <el-option
            v-for="item in status"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-button type="primary" @click="onSubmit(10,1)">搜索</el-button>
    </el-form>
    <el-table :data="listData" border style="width: 100%">
      <el-table-column prop="startTime" label="课程时间" min-width="120"></el-table-column>
      <el-table-column prop="nickName" label="微信名称"></el-table-column>
      <el-table-column prop="userName" label="姓名"></el-table-column>
      <el-table-column prop="mobile" label="手机号"></el-table-column>
      <el-table-column prop="courseType" label="课程类型"></el-table-column>
      <el-table-column prop="orderType" label="预约类型"></el-table-column>
      <el-table-column prop="longTime" label="预约课时"></el-table-column>
      <el-table-column prop="courseStatusName" label="课程状态"></el-table-column>
      <el-table-column prop="statusName" label="订单状态"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            @click="toDetails(scope.row.id,scope.row.courseStatus)"
            type="primary"
            size="small"
          >安排课程</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-box">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="pageAll"
        @current-change="goPage"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import ToolBar from "@/components/ToolBar.vue";
import HelpHint from "@/components/HelpHint.vue";
export default {
  data() {
    return {
      searchParams: {},
      listData: [],
      courseStatus: [
        { label: "全部课程", value: "" },
        { label: "未安排课程", value: 0 },
        { label: "已安排课程", value: 1 }
      ],
      status: [
        { label: "全部状态", value: [0, 1, -1] },
        { label: "未完成", value: [0] },
        { label: "已完成", value: [1] },
        { label: "已取消", value: [-1] }
      ],
      loading: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      searchTime: "",
      pageAll: 1,
      search: false
    };
  },
  mounted() {
    // 查询未安排课程
    this.getList("", 10, 1);
  },
  methods: {
    goPage(e) {
      if (this.search) {
        this.onSubmit(10, e);
      } else {
        this.getList("", 10, e);
      }
    },
    searchTiming() {
      console.log(this.searchTime);
      if (this.searchTime) {
        this.searchParams.startTime = this.searchTime[0];
        this.searchParams.endTime = this.searchTime[1];
      } else {
        this.searchParams.startTime = "";
        this.searchParams.endTime = "";
      }
    },
    onSubmit(size, num) {
      var that = this;
      var that = this;
      that.loading = true;
      that.search = true;
      this.$axios
        .post(this.baseUrl + "/queryOrder", {
          userName: that.searchParams.userName,
          mobile: that.searchParams.mobile,
          courseStatus: that.searchParams.courseStatus,
          status: that.searchParams.status,
          startTime: that.searchParams.startTime,
          endTime: that.searchParams.endTime,
          pageSize: size,
          pageNum: num
        })
        .then(res => {
          that.loading = false;
          console.log(res);
          for (var i = 0; i < res.data.data.list.length; i++) {
            if (res.data.data.list[i].orderType == "1") {
              res.data.data.list[i].orderType = "个人预约";
            } else {
              res.data.data.list[i].orderType = "团体预约";
            }
            if (res.data.data.list[i].courseStatus == "0") {
              res.data.data.list[i].courseStatusName = "未安排";
            } else if (res.data.data.list[i].courseStatus == "1") {
              res.data.data.list[i].courseStatusName = "已安排";
            } else {
              res.data.data.list[i].courseStatusName = "已取消";
            }
            if (res.data.data.list[i].status == "0") {
              res.data.data.list[i].statusName = "未完成";
            } else if (res.data.data.list[i].status == "1") {
              res.data.data.list[i].statusName = "已完成";
            } else {
              res.data.data.list[i].statusName = "已取消";
            }
          }
          that.pageAll = res.data.data.total;
          that.listData = res.data.data.list;
        })
        .catch(error => {
          console.log(error);
        });
    },
    toDetails(id, status) {
      this.$router.push("/post_details?id=" + id + "&courseStatus=" + status)
    },
    getList(val, size, num) {
      var that = this;
      that.loading = true;
      that.search = false;
      that.$axios
        .post(this.baseUrl + "/queryOrder", {
        // .post("/gymTest/queryOrder", {
          courseStatus: val,
          pageSize: size,
          pageNum: num
        })
        .then(res => {
          that.loading = false;
          console.log(res);
          if (res.data.code == 0) {
            for (var i = 0; i < res.data.data.list.length; i++) {
              if (res.data.data.list[i].orderType == "1") {
                res.data.data.list[i].orderType = "个人预约";
              } else {
                res.data.data.list[i].orderType = "团体预约";
              }
              if (res.data.data.list[i].courseStatus == "0") {
                res.data.data.list[i].courseStatusName = "未安排";
              } else if (res.data.data.list[i].courseStatus == "1") {
                res.data.data.list[i].courseStatusName = "已安排";
              } else {
                res.data.data.list[i].courseStatusName = "已取消";
              }
              if (res.data.data.list[i].status == "0") {
                res.data.data.list[i].statusName = "未完成";
              } else if (res.data.data.list[i].status == "1") {
                res.data.data.list[i].statusName = "已完成";
              } else {
                res.data.data.list[i].statusName = "已取消";
              }
            }
            that.pageAll = res.data.data.total;
            that.listData = res.data.data.list;
          } else {
            that.$notify.error({
              title: "网络超时",
              message: "查询订单信息失败！"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  components: {
    ToolBar,
    HelpHint
  }
};
</script>
<style scoped>
.search-form {
  margin: 20px auto 0;
  overflow: hidden;
}
.search-box {
  width: 30%;
  float: left;
}
.time-box {
  width: 60%;
  float: left;
}
.page-box {
  background: #fff;
  text-align: center;
  padding: 20px 0;
}
</style>
